module.exports = __webpack_public_path__ + "static/media/roles.23b003ab.svg";